import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("FPB frontend crash:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
        <section className="max-w-xl w-full bg-white rounded-3xl shadow-xl border border-slate-200 p-8 text-center">
          <img src="/fpb.png" alt="Federal Polytechnic Bida" className="w-20 h-20 object-contain mx-auto mb-4" />
          <h1 className="text-2xl font-extrabold text-slate-900">Something went wrong</h1>
          <p className="mt-3 text-slate-600 leading-7">
            The page had a temporary display problem. You can reload the page or return to the homepage.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <button onClick={() => window.location.reload()} className="px-5 py-3 rounded-full bg-green-700 text-white font-bold">
              Reload page
            </button>
            <a href="/" className="px-5 py-3 rounded-full bg-slate-100 text-slate-800 font-bold">
              Homepage
            </a>
          </div>
        </section>
      </main>
    );
  }
}
